export default (string) =>
  String(string).replace(/(^\w|-\w)/g, (s) => s.replace(/-/, '').toUpperCase());
